import React, { useEffect, useCallback } from 'react'
import { Card } from 'react-bootstrap'
import TabStatus from './TabStatus'
import Search from './Search'
import Pagination from '../../components/Nav/Pagination'
import { useState } from 'react'
import { getRounds } from '../../services/config-services'
import DropdownDate from '../Lottery/DropdownDate'
import { useDispatch } from 'react-redux'
import configs from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import LotteryShowImageModal from './Modal'
import DataList from './DataList'

const InitialStatus = {
  isHide: false,
  isBought: false,
  isPublish: true,
}

const LotteryCountByNumber = () => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)
  const [sortType, setSortType] = useState('DESC')
  const [roundDate, setRoundDate] = useState('')
  const [rounds, setRounds] = useState([])
  const [status, setStatus] = useState(InitialStatus)
  const [searchUser, setSearchUser] = useState('')
  const [searchText, setSearchText] = useState('')
  const [digitsSearchType, setDigitsSearchType] = useState('')
  const [forceUpdate, setForceUpdate] = useState(false)
  const [lengthDigit, setLengthDigit] = useState(6)
  const [dataLists, setDataLists] = useState([])
  const [orderById, setOrderById] = useState('')
  const [isShowImageModal, setIsShowImageModal] = useState(false)

  const showInputSearchUser = status.isHide === true && status.isBought === true && status.isPublish === true

  const handleShowImageModal = (id) => {
    setOrderById(id)
    setIsShowImageModal(true)
  }

  const clearSearch = () => {
    setSearchUser('')
    setSearchText('')
    setSortType('DESC')
    setDigitsSearchType('')
    setCurrentPage(1)
    setForceUpdate(!forceUpdate)
    setLengthDigit(6)
  }

  const onChangePage = (page) => {
    setCurrentPage(page)
  }

  const handleOnChange = (e) => {
    e.preventDefault()

    if (digitsSearchType === '' && searchText.length < 6 && !showInputSearchUser) {
      Swal.fire({
        title: 'กรอกเลขให้ครบ 6 หลัก',
        text: `กรุณากรอกเลขให้ครบ 6 หลัก `,
        icon: 'error',
      })
      return
    }
    fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
  }

  const fetchLotteries = useCallback(
    async (page, searchUser, searchText, status, digitsSearchType, roundDate) => {
      const params = new URLSearchParams()
      params.append('page', page)

      params.append('userNo', searchUser)

      Object.keys(status).forEach((key) => {
        params.append(key, status[key])
      })

      params.append('sort', sortType)

      switch (digitsSearchType) {
        case 'LAST_THREE_DIGITS':
          params.append('number', `...${searchText}`)
          break
        case 'LAST_TWO_DIGITS':
          params.append('number', `....${searchText}`)
          break
        case 'FIRST_THREE_DIGITS':
          params.append('number', `${searchText}...`)
          break
        default:
          searchText = searchText.length === 6 ? searchText : '......'
          params.append('number', `${searchText}`)
          break
      }

      if (roundDate) {
        params.append('roundDate', roundDate)
      }

      try {
        dispatch({ type: 'loading_show' })
        const requestUrl = `${configs.apiAdminGateway}/api/v2/admin/lotteries/countLotteryByNumber?${params.toString()}`
        const getAccessToken = Cookies.get('accessToken')
        const myHeaders = new Headers()
        myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
        myHeaders.append('Content-Type', 'application/json')
        fetch(requestUrl, { method: 'GET', headers: myHeaders })
          .then((response) => response.json())
          .then(async (result) => {
            setDataLists(result.data)
            dispatch({ type: 'loading_hide' })
          })
      } catch (err) {
        setDataLists([])
        dispatch({ type: 'loading_hide' })
      }
    },
    [dispatch, sortType],
  )

  useEffect(() => {
    const fetchAllRounds = async () => {
      const data = await getRounds()
      setRoundDate(data[0].value)
      setRounds(data.map((item) => ({ roundDate: item.value })))
    }
    fetchAllRounds()
  }, [])

  useEffect(() => {
    fetchLotteries(currentPage, searchUser, searchText, status, digitsSearchType, roundDate)
  }, [status, currentPage, forceUpdate, roundDate, sortType])

  const handleChangeTabStatus = (key) => {
    setCurrentPage(1)
    switch (key) {
      case 'HIDE':
        setStatus({ isHide: false, isBought: false, isPublish: false })
        break
      case 'BOUGHT':
        setStatus({ isHide: true, isBought: true, isPublish: true })
        break
      case 'PUBLISH':
        setStatus({ isHide: false, isBought: false, isPublish: true })
        break
      default:
        break
    }
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Lottery count By Number</Card.Title>
      </Card.Header>
      <Card.Body>
        <DropdownDate rounds={rounds} setRoundDate={setRoundDate} />
        <br />
        <TabStatus
          handleChangeTabStatus={handleChangeTabStatus}
          tabSelected={status.isBought ? 'BOUGHT' : status.isPublish ? 'PUBLISH' : 'HIDE'}
          setCurrentPage={setCurrentPage}
        />
        <Search
          setSearchUser={setSearchUser}
          setSearchText={setSearchText}
          handleOnChange={handleOnChange}
          searchUser={searchUser}
          searchText={searchText}
          setDigitsSearchType={setDigitsSearchType}
          setForceUpdate={setForceUpdate}
          forceUpdate={forceUpdate}
          digitsSearchType={digitsSearchType}
          clearSearch={clearSearch}
          fetchLotteries={fetchLotteries}
          status={status}
          roundDate={roundDate}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setLengthDigit={setLengthDigit}
          lengthDigit={lengthDigit}
          setSortType={setSortType}
          sortType={sortType}
        />
        <DataList data={dataLists} handleShowImage={handleShowImageModal} isShowInputSearchUser={showInputSearchUser} />
        <Pagination
          currentPage={currentPage}
          onPrevPage={() => onChangePage(currentPage - 1)}
          onNextPage={() => onChangePage(currentPage + 1)}
          items={dataLists}
          perPage={20}
        />
        <LotteryShowImageModal
          isShow={isShowImageModal}
          onHide={() => setIsShowImageModal(false)}
          orderId={orderById}
        />
      </Card.Body>
    </Card>
  )
}

export default LotteryCountByNumber
